import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';
import styles from './NJChatTextMessage.module.css';
/**
 * Interface for chat text message properties.
 *
 * @interface IChatTextMessageProps
 */
export interface IChatTextMessageProps extends ComponentPropsWithoutRef<'p'> {
  children: ReactNode | ReactNode[];
}

export const NJChatTextMessage = forwardRef<HTMLParagraphElement, IChatTextMessageProps>(
  ({ children, ...props }, ref) => {
    return (
      <p ref={ref} {...props} className={`
        ${styles["nj-chat-text-message"]} 
        ${props.className} 
        `}
      >
        {children}
      </p>
    );
  }
);
